import { createContext, useContext, useState, useCallback, useMemo } from "react";

const translations = {
  nl: {
    // Navigation
    nav_home: "Home",
    nav_services: "Diensten",
    nav_about: "Over Ons",
    nav_projects: "Projecten",
    nav_reviews: "Reviews",
    nav_contact: "Contact",
    nav_cta: "Offerte Aanvragen",
    
    // Hero
    hero_badge: "Jaar Ervaring",
    hero_cta: "Gratis Offerte Aanvragen",
    hero_secondary: "Bekijk Projecten",
    hero_title: "Vakmanschap in",
    hero_title_accent: "Hout & Bouw",
    hero_subtitle: "EG Bouw is uw betrouwbare partner voor timmerwerken, nieuwbouw, renovatie en wand- & plafondafwerking in Eindhoven en omgeving.",
    
    // About dynamic
    about_text1: "Mijn naam is Steven Franken, eigenaar van EG Bouw. Met meer dan 20 jaar ervaring in de bouwsector ben ik uw betrouwbare partner voor al uw klussen in en om het huis.",
    about_text2: "Als allround timmerman combineer ik vakmanschap met een persoonlijke aanpak. Of het nu gaat om een kleine reparatie of een complete verbouwing, ik sta voor kwaliteit, betrouwbaarheid en transparante communicatie.",
    about_title: "20 Jaar Bouwervaring",
    owner_title: "Eigenaar & Allround Timmerman",
    
    // Services
    services_label: "Onze Diensten",
    services_title: "Wat kunnen wij voor u doen?",
    service_timmer: "Timmerwerken",
    service_timmer_desc: "Van maatwerk meubels tot complete houten constructies. Vakkundige uitvoering met oog voor detail.",
    service_nieuwbouw: "Nieuwbouw",
    service_nieuwbouw_desc: "Complete nieuwbouwprojecten van fundament tot oplevering. Professionele begeleiding bij elk project.",
    service_wanden: "Wanden & Plafonds",
    service_wanden_desc: "Strakke afwerking van wanden en plafonds. Stucwerk, gipsplaten en sierlijsten.",
    service_renovatie: "Renovatie",
    service_renovatie_desc: "Geef uw woning een nieuwe uitstraling. Van kleine aanpassingen tot complete verbouwingen.",
    service_cinema: "Cinemawalls",
    service_cinema_desc: "Professionele cinema wanden voor de ultieme thuisbioscoop ervaring. Akoestisch en visueel perfect.",
    
    // About
    about_label: "Over Ons",
    about_years: "Jaar Ervaring",
    about_clients: "Tevreden Klanten",
    
    // Projects
    projects_label: "Portfolio",
    projects_title: "Onze Projecten",
    projects_add: "Project Toevoegen",
    projects_dialog_title: "Nieuw Project Toevoegen",
    projects_dialog_desc: "Voeg een nieuw project toe aan uw portfolio.",
    projects_field_title: "Titel",
    projects_field_desc: "Beschrijving",
    projects_field_image: "Afbeelding uploaden",
    projects_field_image_btn: "Kies afbeelding",
    projects_field_image_url: "Of plak een URL...",
    projects_field_category: "Categorie",
    projects_field_category_placeholder: "Selecteer categorie",
    projects_uploading: "Uploaden...",
    projects_adding: "Toevoegen...",
    projects_submit: "Project Toevoegen",
    
    // Reviews
    reviews_label: "Testimonials",
    reviews_title: "Wat Onze Klanten Zeggen",
    reviews_swipe: "Swipe om meer te zien",
    
    // Quote form
    quote_label: "Contact",
    quote_title: "Vraag Een Offerte Aan",
    quote_subtitle: "Vul onderstaand formulier in en ontvang binnen 24 uur een vrijblijvende offerte.",
    quote_name: "Naam",
    quote_email: "E-mail",
    quote_phone: "Telefoon",
    quote_service: "Dienst",
    quote_service_placeholder: "Selecteer een dienst",
    quote_message: "Bericht",
    quote_message_placeholder: "Beschrijf uw project of vraag...",
    quote_submit: "Offerte Aanvragen",
    quote_submitting: "Verzenden...",
    quote_success: "Offerte aanvraag verzonden! We nemen zo snel mogelijk contact met u op.",
    quote_error: "Er ging iets mis. Probeer het later opnieuw.",
    quote_other: "Anders",
    
    // Contact
    contact_label: "Contact Info",
    contact_title: "Neem Contact Op",
    contact_address: "Adres",
    contact_phone: "Telefoon",
    contact_email: "E-mail",
    contact_business: "Bedrijfsgegevens",
    contact_kvk: "KvK Nummer",
    contact_btw: "BTW Nummer",
    
    // Footer
    footer_desc: "Uw betrouwbare partner voor timmerwerken, nieuwbouw, renovatie en wanden & plafonds in Eindhoven en omgeving.",
    footer_legal: "Juridisch",
    footer_privacy: "Privacybeleid",
    footer_terms: "Algemene Voorwaarden",
    footer_disclaimer: "Disclaimer",
    footer_rights: "Alle rechten voorbehouden.",
    
    // Cookie
    cookie_text: "Wij gebruiken cookies om uw ervaring te verbeteren. Door deze website te gebruiken gaat u akkoord met ons",
    cookie_link: "privacybeleid",
    cookie_accept: "Accepteren",
  },
  en: {
    // Navigation
    nav_home: "Home",
    nav_services: "Services",
    nav_about: "About Us",
    nav_projects: "Projects",
    nav_reviews: "Reviews",
    nav_contact: "Contact",
    nav_cta: "Request Quote",
    
    // Hero
    hero_badge: "Years Experience",
    hero_cta: "Get a Free Quote",
    hero_secondary: "View Projects",
    hero_title: "Craftsmanship in",
    hero_title_accent: "Wood & Construction",
    hero_subtitle: "EG Bouw is your reliable partner for carpentry, new construction, renovation and wall & ceiling finishing in Eindhoven and the surrounding area.",
    
    // About dynamic
    about_text1: "My name is Steven Franken, owner of EG Bouw. With more than 20 years of experience in the construction industry, I am your reliable partner for all your projects in and around the house.",
    about_text2: "As an all-round carpenter, I combine craftsmanship with a personal approach. Whether it's a small repair or a complete renovation, I stand for quality, reliability and transparent communication.",
    about_title: "20 Years of Building Experience",
    owner_title: "Owner & All-Round Carpenter",
    
    // Services
    services_label: "Our Services",
    services_title: "What can we do for you?",
    service_timmer: "Carpentry",
    service_timmer_desc: "From custom furniture to complete wooden structures. Expert craftsmanship with attention to detail.",
    service_nieuwbouw: "New Construction",
    service_nieuwbouw_desc: "Complete new build projects from foundation to delivery. Professional guidance on every project.",
    service_wanden: "Walls & Ceilings",
    service_wanden_desc: "Flawless finishing of walls and ceilings. Plastering, drywall and crown mouldings.",
    service_renovatie: "Renovation",
    service_renovatie_desc: "Give your home a fresh look. From small adjustments to complete remodels.",
    service_cinema: "Cinemawalls",
    service_cinema_desc: "Professional cinema walls for the ultimate home theatre experience. Acoustically and visually perfect.",
    
    // About
    about_label: "About Us",
    about_years: "Years Experience",
    about_clients: "Happy Clients",
    
    // Projects
    projects_label: "Portfolio",
    projects_title: "Our Projects",
    projects_add: "Add Project",
    projects_dialog_title: "Add New Project",
    projects_dialog_desc: "Add a new project to your portfolio.",
    projects_field_title: "Title",
    projects_field_desc: "Description",
    projects_field_image: "Upload image",
    projects_field_image_btn: "Choose image",
    projects_field_image_url: "Or paste a URL...",
    projects_field_category: "Category",
    projects_field_category_placeholder: "Select category",
    projects_uploading: "Uploading...",
    projects_adding: "Adding...",
    projects_submit: "Add Project",
    
    // Reviews
    reviews_label: "Testimonials",
    reviews_title: "What Our Clients Say",
    reviews_swipe: "Swipe to see more",
    
    // Quote form
    quote_label: "Contact",
    quote_title: "Request a Quote",
    quote_subtitle: "Fill in the form below and receive a free quote within 24 hours.",
    quote_name: "Name",
    quote_email: "Email",
    quote_phone: "Phone",
    quote_service: "Service",
    quote_service_placeholder: "Select a service",
    quote_message: "Message",
    quote_message_placeholder: "Describe your project or question...",
    quote_submit: "Request Quote",
    quote_submitting: "Sending...",
    quote_success: "Quote request sent! We will contact you as soon as possible.",
    quote_error: "Something went wrong. Please try again later.",
    quote_other: "Other",
    
    // Contact
    contact_label: "Contact Info",
    contact_title: "Get in Touch",
    contact_address: "Address",
    contact_phone: "Phone",
    contact_email: "Email",
    contact_business: "Business Details",
    contact_kvk: "Chamber of Commerce",
    contact_btw: "VAT Number",
    
    // Footer
    footer_desc: "Your reliable partner for carpentry, new construction, renovation and walls & ceilings in Eindhoven and surroundings.",
    footer_legal: "Legal",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms & Conditions",
    footer_disclaimer: "Disclaimer",
    footer_rights: "All rights reserved.",
    
    // Cookie
    cookie_text: "We use cookies to improve your experience. By using this website you agree to our",
    cookie_link: "privacy policy",
    cookie_accept: "Accept",
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("eg_lang") || "nl";
  });

  const toggleLanguage = useCallback(() => {
    setLang((prev) => {
      const next = prev === "nl" ? "en" : "nl";
      localStorage.setItem("eg_lang", next);
      return next;
    });
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.nl[key] || key;
  }, [lang]);

  const value = useMemo(() => ({ lang, toggleLanguage, t }), [lang, toggleLanguage, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
